import { PlanType, PlanStatus, MilestoneStatus, SubtaskStatus, PlanSortField, SortOrder } from '../types/plan';

// Plan type options
export const PLAN_TYPE_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'Major' as PlanType, label: '重大计划' },
  { value: 'Regular' as PlanType, label: '常规计划' },
  { value: 'Minor' as PlanType, label: '小幅计划' },
  { value: 'Urgent' as PlanType, label: '紧急计划' },
  { value: 'Special' as PlanType, label: '特殊计划' },
];

// Plan status options
export const PLAN_STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'Pending' as PlanStatus, label: '待启动' },
  { value: 'InProgress' as PlanStatus, label: '进行中' },
  { value: 'Completed' as PlanStatus, label: '已完成' },
  { value: 'Cancelled' as PlanStatus, label: '已取消' },
  { value: 'Paused' as PlanStatus, label: '已暂停' },
];

// Milestone status options
export const MILESTONE_STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'NotStarted' as MilestoneStatus, label: '未开始' },
  { value: 'InProgress' as MilestoneStatus, label: '进行中' },
  { value: 'Completed' as MilestoneStatus, label: '已完成' },
  { value: 'Skipped' as MilestoneStatus, label: '已跳过' },
  { value: 'Overdue' as MilestoneStatus, label: '已逾期' },
];

// Subtask status options
export const SUBTASK_STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'NotStarted' as SubtaskStatus, label: '未开始' },
  { value: 'InProgress' as SubtaskStatus, label: '进行中' },
  { value: 'Completed' as SubtaskStatus, label: '已完成' },
  { value: 'Skipped' as SubtaskStatus, label: '已跳过' },
];

// Pagination options for plan list
export const PLAN_PAGE_SIZES = [20, 50, 100];
export const PLAN_DEFAULT_PAGE_SIZE = 20;

// Default pagination settings for plans
export const PLAN_PAGINATION_DEFAULT = {
  currentPage: 1,
  pageSize: PLAN_DEFAULT_PAGE_SIZE,
  sortBy: 'gmtModified' as PlanSortField,
  sortOrder: 'desc' as SortOrder,
};

// Plan validation rules
export const PLAN_VALIDATION_RULES = {
  planCode: {
    required: false, // Auto-generated for create
    pattern: /^TEMP\d+_\d+_\d{8}$/,
    message: '计划编码格式不正确，应为TEMP{templateId}_{weekNumber}_{date}',
  },
  planName: {
    required: true,
    max: 100,
    message: '计划名称为必填项，长度不能超过100个字符',
  },
  planType: {
    required: true,
    message: '请选择计划类型',
  },
  templateReference: {
    required: true,
    message: '请选择模板引用',
  },
  templateOwner: {
    required: true,
    message: '请选择模板负责人',
  },
  storeGroupScope: {
    required: true,
    message: '请选择门店组范围',
  },
  description: {
    max: 500,
    message: '描述长度不能超过500个字符',
  },
};



// 计划状态配置（用于 StatusTag 组件）
export const PLAN_STATUS_CONFIG = {
  options: [
    { value: 'Pending', label: '未开始' },
    { value: 'InProgress', label: '进行中' },
    { value: 'Completed', label: '已完成' },
    { value: 'Paused', label: '已暂停' },
    { value: 'Cancelled', label: '已取消' }
  ],
  colors: {
    'Pending': 'default',
    'InProgress': 'processing',
    'Completed': 'success',
    'Paused': 'warning',
    'Cancelled': 'error'
  }
};

// 里程碑状态配置（用于 StatusTag 组件）
export const MILESTONE_STATUS_CONFIG = {
  options: [
    { value: 'NotStarted', label: '未开始' },
    { value: 'InProgress', label: '进行中' },
    { value: 'Completed', label: '已完成' },
    { value: 'Overdue', label: '已逾期' }
  ],
  colors: {
    'NotStarted': 'default',
    'InProgress': 'processing',
    'Completed': 'success',
    'Overdue': 'error'
  }
};

// 计划类型配置（用于 StatusTag 组件）
export const PLAN_TYPE_CONFIG = {
  options: [
    { value: 'Major', label: '重大计划' },
    { value: 'Regular', label: '常规计划' },
    { value: 'Minor', label: '小型计划' },
    { value: 'Urgent', label: '紧急计划' },
    { value: 'Special', label: '特殊计划' }
  ],
  colors: {
    'Major': 'red',
    'Regular': 'blue',
    'Minor': 'green',
    'Urgent': 'orange',
    'Special': 'purple'
  }
};